import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import download from "downloadjs";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
import {RootState} from "app/store";

interface ISummaryTableExcel {
    from?: string;
    to?: string;
    includeEnded?: boolean;
}


export const getSummaryTableExcel = createAsyncThunk(
    "summaryTable/getSummaryTableExcel",
    async ({ from, to, includeEnded }: ISummaryTableExcel, thunkAPI) => {

        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }

            const { token } = JSON.parse(authToken);
            const state = thunkAPI.getState() as RootState;
            const filters = state.summaryTable.filters;
            const resolvedFrom = from !== undefined ? from : filters.from;
            const resolvedTo = to !== undefined ? to : filters.to;
            const resolvedIncludeEnded = includeEnded !== undefined ? includeEnded : filters.includeEnded;

            const params = createRequestParams(
                resolvedFrom,
                resolvedTo,
                undefined,
                undefined,
                resolvedIncludeEnded,
            );

            const response = await axios.get(`/api/pivot-table/report`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
                params,
            });

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            download(response.data, "file.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

            return response.data;
        } catch (error) {
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);
